/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';

/**
 * 
 * @export
 * @interface SubscriptionChangeResponse
 */
export interface SubscriptionChangeResponse {
    /**
     * 
     * @type {Price}
     * @memberof SubscriptionChangeResponse
     */
    proration?: Price;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionChangeResponse
     */
    upgrade?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionChangeResponse
     */
    proratedDays?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionChangeResponse
     */
    periodLength?: number;
}

/**
 * Check if a given object implements the SubscriptionChangeResponse interface.
 */
export function instanceOfSubscriptionChangeResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SubscriptionChangeResponseFromJSON(json: any): SubscriptionChangeResponse {
    return SubscriptionChangeResponseFromJSONTyped(json, false);
}

export function SubscriptionChangeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionChangeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'proration': !exists(json, 'proration') ? undefined : PriceFromJSON(json['proration']),
        'upgrade': !exists(json, 'upgrade') ? undefined : json['upgrade'],
        'proratedDays': !exists(json, 'proratedDays') ? undefined : json['proratedDays'],
        'periodLength': !exists(json, 'periodLength') ? undefined : json['periodLength'],
    };
}

export function SubscriptionChangeResponseToJSON(value?: SubscriptionChangeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'proration': PriceToJSON(value.proration),
        'upgrade': value.upgrade,
        'proratedDays': value.proratedDays,
        'periodLength': value.periodLength,
    };
}

